import { Area } from "./area"
import { Customer } from "./customer"
import { News } from "./news"
import { Product } from "./product"
import { Shop } from "./shop"
import { Staff } from "./staff"

export enum NotificationType {
    Order = 'ORDER',
    News = 'NEWS',
    Shop = 'SHOP',
    Product = 'PRODUCT',
    Normal = 'NORMAL' //k gắn gì
}



export enum NotificationMode {
    Global = 'GLOBAL', //Tất cả user
    Private = 'PRIVATE', // riêng cá nhân
    Range = 'RANGE' // cho 1 group user
}




export interface Notification {
    id: number
    createdAt: number
    updatedAt: number
    isDeleted: boolean
    title: string
    content: string
    type: NotificationType
    mode: NotificationMode
    lastSentAt: number;
    customer?: Customer;
    news?: News;
    area?: Area;
    staffSent?: Staff;
    shop?: Shop;
    product?: Product;
}
